import PropTypes from 'prop-types'
import { PropTypes as MobXPropTypes } from 'mobx-react'
import React from 'react'
import { makeDataUrl } from '../utils'

function getFileType(name) {
  const ending = name.split('.').slice(-1)[0]
  if (!ending) {
    return name
  }
  return ending.toUpperCase()
}

export default
function FileList({ list, type = 'image' }) {

  return (
    <ul className="file-list">

      {list.length
        ? list.map(item => (
          <li key={`file-item-${item.url}`}>
            {type === 'image'
              ? (
                <img
                  role="presentation"
                  className="thumbnail"
                  src={makeDataUrl(item)}
                />
              )
              : null}

            <a
              href={makeDataUrl(item)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.pivot && item.pivot.description
                ? item.pivot.description
                : ''}
            </a>
            {item.name ? (
              <small>&nbsp;(
                {getFileType(item.name)}
                )
              </small>
            ) : null}
          </li>
        ))
        : (
          <li>
            <em>
              Keine
              {' '}
              {type === 'image' ? 'Bilder' : 'Dateien'}
              {' '}
              vorhanden
            </em>
          </li>
        )}

    </ul>
  )
}

FileList.propTypes = {
  list: MobXPropTypes.observableArray,
  type: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/shared/components/FileList.js